<template>
  <div class="a">
    <top></top>
    <navs></navs>
    <div class="content">
      <div class="cont">
        <div class="cont_left">
          <div class="cont_a">
            <div class="bule"></div>
            <div class="p">{{ name }}</div>
          </div>
          <div class="cont_left_top">
            <video :src="vid[0].url" controls height="396px" width="100%"></video>
          </div>
          <div class="recommend">
            <span style="margin-left: 20px;">标签推荐：</span>
            <div v-for="(item, index) in recommend" :key="index" class="label" @click="recomm(item.id)">#{{
                item.name
              }}
            </div>
          </div>
        </div>
        <div class="cont_right">
          <div class="cont_a">
            <div class="bule"></div>
            <div class="p">播放列表</div>
          </div>
          <div class="directory">
            <div v-for="(item, index) in list" :key="index" :class="{ con: d === item.id }" class="text"
                 @click="transfrom(item.id)">
              <div class="hidden">{{ item.name }}</div>
              <p>&gt;</p>
            </div>

          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import axios from "axios"

export default {
  components: {
    top,
    bottom,
    navs
  },
  data() {
    return {
      vid: [],
      list: [],
      recommend: [],
      name: "",
      d: "",
      id: ""
    }

  },
  created() {
    let that = this
    axios({
      method: "GET",
      url: "https://www.jnccljh.com/api/records/pages",
      params: {

        "albumId": that.$route.query.id,
        pageSize: 9999,
      }
    }).then(res => {
      console.log(res)
      this.list = res.data.data.records
      axios({
        method: "GET",
        url: "https://www.jnccljh.com/api/records/" + res.data.data.records[0].id
      }).then(res => {
        console.log(res)
        that.vid = res.data.data.metadataList
        that.name = res.data.data.name
      })
    })

    axios({
      method: "GET",
      url: "https://www.jnccljh.com/api/records/" + that.$route.query.id + "/tags"
    }).then(res => {
      console.log(res)
      that.recommend = res.data.data
    })

  },
  methods: {
    transfrom(item) {
      this.d = item
      axios({
        method: "GET",
        url: "https://www.jnccljh.com/api/records/" + item
      }).then(res => {

        this.vid = res.data.data.metadataList
        this.name = res.data.data.name
      })
    },
    recomm(item) {
      this.$router.push({path: "/album", query: {id: item}})
    }
  }
}
</script>
<style scoped>
.a {
  width: 100%;
  /* height: 100vh; */
  margin: 0;
  padding: 0;
  background-color: #F7F7F7;
}

.content {
  width: 100%;
  /* height: 480px; */
  /* height: 1330px; */
  background-image: url(../image/back.png);
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cont {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.cont_left {
  width: 65%;

}

.cont_left_top {
  width: 100%;
  height: 396px;
  background-color: #FFFFFF;
}

/* .title{
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 100%;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image{
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
} */
.cont_right {
  width: 28%;
}

.cont_a {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.bule {
  width: 5px;
  height: 16px;
  background: #1463FF;
  /* margin: 20px 0; */

}

.p {
  margin-left: 5px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333333;
  line-height: 17px;
  font-style: normal;
}

.directory {
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 50px;

  overflow-y: auto;
  /* 启用垂直滚动 */
  /* height: 800px; */
  height: auto;
  max-height: 410px;
}

.recommend {
  margin: 20px 0;
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  /* padding-left: 20px; */
}

.label {
  width: 59px;
  height: 27px;
  background: #EEEEEE;
  border-radius: 13px;
  border: 1px solid #979797;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.label:hover {
  background: #F9F9F9;
  border-radius: 13px;
  border: 1px solid #1463FF;
  width: 59px;
  height: 27px;
  background: #EEEEEE;
  border-radius: 13px;
  color: #1463FF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  width: 80%;
  height: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
}

.text:hover {
  width: 80%;
  height: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #1463FF;
}

.hidden {
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.con {
  color: #1463FF;
}
</style>



// WEBPACK FOOTER //
// src/views/mebf.vue